module.exports = __webpack_public_path__ + "static/media/naztec.45a6e171.svg";